import { Dialog } from "@mui/material";
import { MentionModel } from "../communication";
import { crossSVG } from '../constants';

interface ModalProps {
	content: JSX.Element[];
	open: boolean;
	header: string;
	handleClose: () => void;
	emptyInfo?: string;
	mentionModel?: MentionModel;
}

export default function Modal(props: ModalProps) {
	const content =
		props.emptyInfo !== undefined ? (
			<div className="empty-info">
				<p>{props.emptyInfo}</p>
			</div>
		) : (
			<div className="content">{props.content}</div>
		);

	return (
		<Dialog
			open={props.open}
			onClose={props.handleClose}
			sx={{
				"> .MuiBackdrop-root": {
					backdropFilter: "blur(8px)",
				},
			}}>
			<div className="metadata-modal" key={props.header}>
				<div className={"header " + props.mentionModel}>
					<h1>{props.header}</h1>
					<div className="close" onClick={props.handleClose}>
						{crossSVG}
					</div>
				</div>
				{content}
			</div>
		</Dialog>
	);
}
